// /////////////////////////////////////////////////////////////////////////////////////
//                              Copyright (c) 2020 - 2026
//                                    RXO Inc.
//                          All Rights Reserved Worldwide
//
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
// /////////////////////////////////////////////////////////////////////////////////////

import messages from "./messages";

export const mode = {
  tl: 1,
  ltl: 2,
  imdl: 3
};

export const status = {
  pending: 1,
  rejected: 2,
  inProgress: 3,
  submitted: 4,
  feedback: 5,
  closed: 6
};

export const division = {
  coy: 1,
  eu: 5
};

export const userRole = {
  salesRep: 1,
  tlPricingAnalyst: 2,
  ltlPricingAnalyst: 3,
  imdlPricingAnalyst: 4,
  salesManager: 5,
  operations: 6,
  assetBasedPricingUser: 7,
  management: 8,
  carrierRelationsRepresentative: 9,
  procurementRepresentative: 10
};

export const dateFormat = {
  ddMMMyyy: "dd-MMM-yyy",
  yyyMMdd: "yyy-MM-dd",
  MMddyy: "MM/dd/yy",
  ddMMyy: "dd/MM/yy",
  hmma: "h:mm a",
  ddMMyyyy: "dd/MM/yyyy",
  MMddyyyy: "MM/dd/yyyy",
  yyyMMM: "yyy-MMM",
  MMddyyyyhmma: "MM/dd/yyyy 'at' h:mm a",
  ddMMyyyyhmma: "dd/MM/yyyy 'at' h:mm a",
  yyyMM: "yyy-MM"
};

export const order = {
  ascending: "asc",
  descending: "desc"
};

export const loadModes = {
  TL: {
    label: messages.tl.defaultMessage,
    value: 1
  },
  LTL: {
    label: messages.ltl.defaultMessage,
    value: 2
  },
  IMDL: {
    label: messages.imdl.defaultMessage,
    value: 3
  }
};

export const pendingBidsSortableFields = {
  rfqName: "bidName",
  mainRepFullName: "mainRepFullName",
  shipperName: "shipperName",
  deadline: "deadlineUTC",
  laneCount: "laneCount",
  volume: "volume",
  mode: "mode",
  pending: "lastStatusChangeDateUTC",
  defaultOrder: "defaultOrder"
};

export const bidOutputFormatsTypes = [
  { value: 1, label: messages.pointToPoint.defaultMessage },
  { value: 2, label: messages.pointToRegion.defaultMessage },
  { value: 3, label: messages.pointToState.defaultMessage },
  { value: 4, label: messages.regionToPoint.defaultMessage },
  { value: 5, label: messages.regionToRegion.defaultMessage },
  { value: 6, label: messages.regionToState.defaultMessage },
  { value: 7, label: messages.stateToPoint.defaultMessage },
  { value: 8, label: messages.stateToRegion.defaultMessage },
  { value: 9, label: messages.stateToState.defaultMessage },
  { value: 10, label: messages.clusters.defaultMessage },
  { value: 11, label: messages.percentOfLaneVolume.defaultMessage }
];

export const operationalCenters = [
  { value: "ANN2", label: "ANN2 - Ann Arbor" },
  { value: "ANN", label: "ANN - Ann Arbor" },
  { value: "CATL", label: "CATL - Atlanta" },
  { value: "CCHATT", label: "CCHATT - Chattanooga" },
  { value: "CDEN2", label: "CDEN2 - Denver" },
  { value: "CDEN", label: "CDEN - Denver" },
  { value: "CDET2", label: "CDET2 - Detroit" },
  { value: "CDET", label: "CDET - Detroit" },
  { value: "CGXS1", label: "CGXS1 - GX Solutions Chicago" },
  { value: "CGXS2", label: "CGXS2 - GX Solutions Chicago" },
  { value: "CGXS3", label: "CGXS3 - GX Solutions Chicago" },
  { value: "CHA1", label: "CHA1 - Charlotte" },
  { value: "CHA3", label: "CHA3 - Charlotte" },
  { value: "CHA5", label: "CHA5 - Charlotte" },
  { value: "CHI", label: "CHI - Chicago" },
  { value: "CKNX", label: "CKNX - Knoxville" },
  { value: "CLT1", label: "CLT1 - Spencer" },
  { value: "CLT2", label: "CLT2 - Spencer" },
  { value: "CLT3", label: "CLT3 - Spencer" },
  { value: "CLT4", label: "CLT4 - Spencer" },
  { value: "CLU", label: "CLU - Columbia" },
  { value: "CMH", label: "CMH - Columbus" },
  { value: "CMPLS2", label: "CMPLS2 - Minneapolis" },
  { value: "CMPLS", label: "CMPLS - Minneapolis" },
  { value: "DAL", label: "DAL - Dallas" },
  { value: "DEN", label: "DEN - Denver" },
  { value: "DET", label: "DET - Detroit" },
  { value: "DRAY", label: "DRAY" },
  { value: "GAI1", label: "GAI1 - Gainesville" },
  { value: "GAI2", label: "GAI2 - Gainesville" },
  { value: "GAI3", label: "GAI3 - Gainesville" },
  { value: "GAI4", label: "GAI4 - Gainesville" },
  { value: "GX1", label: "GX1 - Chicago" },
  { value: "GX2", label: "GX2 - Chicago" },
  { value: "GX3", label: "GX3 - Chicago" },
  { value: "GX4", label: "GX4 - Chicago" },
  { value: "GX5", label: "GX5 - Chicago" },
  { value: "GX6", label: "GX6 - Chicago" },
  { value: "GX7", label: "GX7 - Chicago" },
  { value: "JAX", label: "JAX - Jacksonville" },
  { value: "KCM1", label: "KCM1 - Des Moines" },
  { value: "KCM2", label: "KCM2 - Des Moines" },
  { value: "LAK", label: "LAK - Lake Forest" },
  { value: "LAR", label: "LAR - Laredo" },
  { value: "MCI", label: "MCI - Kansas City" },
  { value: "MTRA", label: "MTRA - Managed Trans" },
  { value: "MX", label: "MX - Mexico" },
  { value: "PHX2", label: "PHX2 - Phoenix" },
  { value: "PHX", label: "PHX - Phoenix" },
  { value: "RIC", label: "RIC - Richmond" },
  { value: "SMBATL", label: "SMBATL - SMB Atlanta" },
  { value: "SMBCHATT", label: "SMBCHATT - SMB Chattanooga" },
  { value: "SMBCHI", label: "SMBCHI - SMB Chicago" },
  { value: "SMBCMH", label: "SMBCMH - SMB Columbus" },
  { value: "SMBDEN", label: "SMBDEN - SMB Denver" },
  { value: "SMBDET", label: "SMBDET - SMB Detroit" },
  { value: "SMBKNX", label: "SMBKNX - SMB Knoxville" },
  { value: "SMBMPLS", label: "SMBMPLS - SMB Minneapolis" },
  { value: "UPSREPO", label: "UPSREPO - Trailer Repo" },
  { value: "USREPO", label: "USREPO - Trailer Repo" },
  { value: "VAN2", label: "VAN2 - Vancouver" },
  { value: "VAN", label: "VAN - Vancouver" }
];

export const rfqStatusTypes = [
  { value: 1, label: messages.pending.defaultMessage },
  { value: 2, label: messages.rejected.defaultMessage },
  { value: 3, label: messages.inProgress.defaultMessage },
  { value: 4, label: messages.submitted.defaultMessage },
  { value: 5, label: messages.feedback.defaultMessage },
  { value: 6, label: messages.closed.defaultMessage }
];

export const contractOnFileTypes = [
  { value: true, label: messages.yes.defaultMessage },
  { value: false, label: messages.no.defaultMessage }
];

export const mileageBasisTypes = [
  {
    division: division.coy,
    value: 1,
    label: messages.coyoteMiles.defaultMessage
  },
  { division: division.coy, value: 2, label: messages.pcMiler.defaultMessage },
  {
    division: division.coy,
    value: 3,
    label: messages.randMcNally.defaultMessage
  },
  { division: division.eu, value: 5, label: messages.bingApi.defaultMessage },
  {
    division: division.eu,
    value: 6,
    label: messages.tlnPlanner.defaultMessage
  },
  { division: division.eu, value: 7, label: messages.rcKm.defaultMessage },
  { value: 4, label: messages.other.defaultMessage }
];

export const tenderLeadTimeTypes = [
  { value: 1, label: messages.sameDay.defaultMessage },
  { value: 2, label: messages.hours24.defaultMessage },
  { value: 3, label: messages.hours24To48.defaultMessage },
  { value: 4, label: messages.hours48To1Week.defaultMessage },
  { value: 5, label: messages.moreThan1Week.defaultMessage }
];

export const fscTypes = [
  {
    value: 1,
    label: messages.ratePerMile.defaultMessage,
    division: division.coy
  },
  { value: 1, label: messages.ratePerKM.defaultMessage, division: division.eu },
  { value: 2, label: messages.percentOfRate.defaultMessage, division: null },
  { value: 3, label: messages.breakthrough.defaultMessage, division: null }
];

export const equipmentTypes = [
  {
    value: 1,
    type: 1,
    length: null,
    label: messages.van.defaultMessage,
    division: null
  },
  {
    value: 2,
    type: 2,
    length: null,
    label: messages.reefer.defaultMessage,
    division: null
  },
  {
    value: 3,
    type: 3,
    length: 48,
    label: messages.flatbed48.defaultMessage,
    division: null
  },
  {
    value: 4,
    type: 3,
    length: 53,
    label: messages.flatbed53.defaultMessage,
    division: null
  },
  {
    value: 6,
    type: 6,
    length: null,
    label: messages.stepDeck.defaultMessage,
    division: division.coy
  },
  {
    value: 28,
    type: 28,
    length: null,
    label: messages.removableGooseNeck.defaultMessage,
    division: division.coy
  },
  {
    value: 29,
    type: 29,
    length: null,
    label: messages.conestoga.defaultMessage,
    division: division.coy
  },
  {
    value: 8,
    type: 8,
    length: null,
    label: messages.doubleDrop.defaultMessage,
    division: division.eu
  },
  {
    value: 11,
    type: 11,
    length: null,
    label: messages.euroliner.defaultMessage,
    division: division.eu
  },
  {
    value: 12,
    type: 12,
    length: null,
    label: messages.tilt.defaultMessage,
    division: division.eu
  },
  {
    value: 16,
    type: 16,
    length: null,
    label: messages.megatrailer.defaultMessage,
    division: division.eu
  },
  {
    value: 17,
    type: 17,
    length: null,
    label: messages.roadTrain.defaultMessage,
    division: division.eu
  },
  {
    value: 18,
    type: 18,
    length: null,
    label: messages.powerOnly.defaultMessage,
    division: null
  },
  {
    value: 33,
    type: 33,
    length: null,
    label: messages.boxTrailer.defaultMessage,
    division: division.eu
  },
  {
    value: 71,
    type: 71,
    length: null,
    label: messages.finishedVehicleLogistics.defaultMessage,
    division: null
  },
  {
    value: 72,
    type: 72,
    length: null,
    label: messages.bulkTanker.defaultMessage,
    division: null
   },
  {
    value: 73,
    type: 73,
    length: null,
    label: messages.overDimensionalSpecialized.defaultMessage,
    division: null
  }
];

export const currencyTypes = [
  { value: 1, label: "USD" },
  { value: 2, label: "CAD" },
  { value: 3, label: "MXN" },
  { value: 9, label: "EUR" },
  { value: 10, label: "GBP" },
  { value: 135, label: "PLN" },
  { value: 209, label: "Multiple Currencies" }
];

export const freightClassTypes = [
  { value: 1, label: "50" },
  { value: 2, label: "55" },
  { value: 3, label: "60" },
  { value: 4, label: "65" },
  { value: 5, label: "70" },
  { value: 6, label: "77.5" },
  { value: 7, label: "85" },
  { value: 8, label: "92.5" },
  { value: 9, label: "100" },
  { value: 10, label: "110" },
  { value: 11, label: "125" },
  { value: 12, label: "150" },
  { value: 13, label: "175" },
  { value: 14, label: "200" },
  { value: 15, label: "250" },
  { value: 16, label: "300" },
  { value: 17, label: "400" },
  { value: 18, label: "500" },
  { value: 19, label: "775" },
  { value: 20, label: "925" }
];

export const booleanTypes = [
  { value: true, label: messages.yes.defaultMessage },
  { value: false, label: messages.no.defaultMessage }
];

export const rateReturnTypes = [
  { value: 1, label: messages.hundredweight.defaultMessage },
  { value: 2, label: messages.discountsOrMinimums.defaultMessage },
  { value: 3, label: messages.flatRate.defaultMessage },
  { value: 4, label: messages.palletRating.defaultMessage },
  { value: 5, label: messages.ratePerLB.defaultMessage }
];

export const ltlAcessorialTypes = [
  { value: 1, label: messages.none.defaultMessage },
  { value: 2, label: messages.inside.defaultMessage },
  { value: 3, label: messages.appointmentRequired.defaultMessage },
  { value: 4, label: messages.residential.defaultMessage },
  { value: 5, label: messages.palletJack.defaultMessage },
  { value: 6, label: messages.tradeshow.defaultMessage },
  { value: 7, label: messages.sortAndSegregate.defaultMessage },
  { value: 8, label: messages.liftGate.defaultMessage },
  { value: 9, label: messages.markingAndTagging.defaultMessage },
  { value: 10, label: messages.stopNotification.defaultMessage },
  { value: 11, label: messages.limitedAccess.defaultMessage }
];

export const containerSizeTypes = [
  { value: 53, label: "53" },
  { value: 40, label: "40" },
  { value: 45, label: "45" },
  { value: 20, label: "20" }
];

export const imdlSolutionTypes = [
  { value: 40, label: "40' Ocean Box" },
  { value: 53, label: "53' Domestic Container" }
];

export const bidStrategyTypes = [
  { value: 0, label: messages.none.defaultMessage },
  { value: 1, label: messages.dontHaveABidStrategy.defaultMessage },
  { value: 2, label: messages.primaryOnly.defaultMessage },
  { value: 3, label: messages.primaryAndBackup.defaultMessage },
  { value: 4, label: messages.backupOnly.defaultMessage },
  { value: 5, label: messages.cactusQuickbidOpportunity.defaultMessage }
];

export const shipperTenderStrategyTypes = [
  { value: 0, label: messages.none.defaultMessage },
  { value: 1, label: messages.primaryBackup.defaultMessage },
  { value: 2, label: messages.primarySecondaryBackup.defaultMessage },
  { value: 3, label: messages.waterfallRank1To50.defaultMessage },
  { value: 4, label: messages.other.defaultMessage }
];

export const messageType = {
  system: 1,
  user: 2
};

export const awardStatus = {
  won: 1,
  lost: 2
};

export const fileStatus = {
  uploaded: 1,
  notUploaded: 2,
  inProgress: 3,
  error: 4,
  conflict: 5
};

export const controls = {
  textInput: 1,
  checkbox: 2,
  none: 3,
  delete: 4,
  laneMatch: 5,
  button: 6,
  tag: 7,
  hide: 8,
  dropdown: 9
};

export const modeName = {
  1: "Truckload",
  2: "Lessthan Truckload",
  3: "Intermodal"
};

export const laneType = {
  standardTruckload: 1,
  euTruckload: 2,
  lessThanTruckload: 3,
  intermodal: 4
};

export const loadingType = {
  0: "",
  1: "Drop",
  2: "Live"
};

export const statusText = {
  pending: messages.pending.defaultMessage,
  inProgress: messages.inProgress.defaultMessage,
  submitted: messages.submitted.defaultMessage,
  feedback: messages.feedback.defaultMessage,
  awarded: messages.awarded.defaultMessage,
  lost: messages.lost.defaultMessage,
  archived: messages.archived.defaultMessage,
  closed: messages.closed.defaultMessage,
  rejected: messages.rejected.defaultMessage
};

export const modeOptions = [
  {
    label: messages.tl.defaultMessage,
    key: 1,
    value: 1
  },
  {
    label: messages.ltl.defaultMessage,
    key: 2,
    value: 2
  },
  {
    label: messages.imdl.defaultMessage,
    key: 3,
    value: 3
  }
];

export const statusOptions = [
  {
    label: messages.pending.defaultMessage,
    key: 1,
    value: 1
  },
  {
    label: messages.inProgress.defaultMessage,
    key: 2,
    value: 3
  },
  {
    label: messages.submitted.defaultMessage,
    key: 3,
    value: 4
  },
  {
    label: messages.feedback.defaultMessage,
    key: 4,
    value: 5
  },
  {
    label: messages.awarded.defaultMessage,
    key: 5,
    value: 1
  },
  {
    label: messages.lost.defaultMessage,
    key: 6,
    value: 2
  },
  {
    label: messages.archived.defaultMessage,
    key: 7
  }
];

export const httpResponseStatus = {
  conflict: 409,
  internalServerError: 500,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403
};

export const equipments = {
  1: messages.van.defaultMessage,
  2: messages.reefer.defaultMessage,
  3: messages.flatbed.defaultMessage,
  5: messages.container.defaultMessage,
  6: messages.stepDeck.defaultMessage,
  7: messages.dropFrame.defaultMessage,
  8: messages.doubleDrop.defaultMessage,
  9: messages.softShell.defaultMessage,
  10: messages.flatbedWithTarp.defaultMessage,
  11: messages.euroliner.defaultMessage,
  12: messages.tilt.defaultMessage,
  13: messages.bulk.defaultMessage,
  15: messages.tanker.defaultMessage,
  16: messages.megatrailer.defaultMessage,
  17: messages.roadTrain.defaultMessage,
  18: messages.powerOnly.defaultMessage,
  19: "CNRU",
  20: "CPPU",
  21: "CSXU",
  22: "EMHU",
  23: "EMPU",
  24: "EMWU",
  25: "EPTY",
  26: "PACU",
  27: messages.ventedVan.defaultMessage,
  28: messages.removableGooseNeck.defaultMessage,
  29: messages.conestoga.defaultMessage,
  30: messages.deckedReefer.defaultMessage,
  31: messages.heatedVan.defaultMessage,
  32: messages.flatbedWithSides.defaultMessage,
  33: messages.boxTrailer.defaultMessage,
  34: messages.siloTanker.defaultMessage,
  35: messages.boxcar.defaultMessage,
  36: messages.maxiVan.defaultMessage,
  37: messages.maxiFlatbed.defaultMessage,
  38: messages.flatCar.defaultMessage,
  39: messages.duraplateVan.defaultMessage,
  40: messages.landall.defaultMessage,
  41: messages.stepdeckWithRamps.defaultMessage,
  42: messages.autoTrailer.defaultMessage,
  43: messages.beamTrailer.defaultMessage,
  44: messages.reeferContainer.defaultMessage,
  45: messages.hotShot.defaultMessage,
  46: messages.rgnMultiAxel.defaultMessage,
  47: messages.rgnStretch.defaultMessage,
  48: messages.flatbedStretch.defaultMessage,
  49: messages.stepdeckStretch.defaultMessage,
  50: messages.roadtrainCurtain.defaultMessage,
  51: messages.roadtrainBox.defaultMessage,
  52: messages.walkingFloorBox.defaultMessage,
  53: messages.powerOnlyTraction.defaultMessage,
  54: messages.doubledeckTaut.defaultMessage,
  55: messages.doubledeckBox.defaultMessage,
  56: messages.doubledeckFridge.defaultMessage,
  57: messages.stepframeBox.defaultMessage,
  58: messages.stepframeCurtain.defaultMessage,
  59: messages.rollerbedCurtain.defaultMessage,
  60: messages.flatbed.defaultMessage,
  61: messages.flatbedTwistlocks.defaultMessage,
  62: messages.extendibleFlatbed.defaultMessage,
  63: messages.skeletalContainer.defaultMessage,
  64: messages.lowLoader.defaultMessage,
  65: messages.semiLowLoader.defaultMessage,
  66: messages.extendibleLowLoader.defaultMessage,
  67: messages.tankerChemicals.defaultMessage,
  68: messages.tankerFood.defaultMessage,
  69: messages.intermodal.defaultMessage,
  70: messages.intermodalFridge.defaultMessage
};

export const patterns = {
  positiveInteger: /^\d{0,9}$/,
  intTwoFractionalTwo: /^\d{0,2}(|\.\d{0,2})$/,
  intSixFractionalTwo: /^\d{0,6}(|\.\d{0,2})$/,
  maxThousandCharacters: /^[\s\S]{0,1000}$/,
  maxFiftyCharacters: /^[\s\S]{0,50}$/,
  intFourFractionalOne: /^\d{0,4}(|\.\d{0,1})$/,
  minOneIntFourFractionalOne: /^(([1-9]\d{0,3})(\.\d?)?)?$/,
  intFourFractionalTwo: /^\d{0,4}(|\.\d{0,2})$/,
  userMentions: /^(\s|\S)*(@\[([a-zA-Z0-9-]+\s?)*\]\(-?\d+\))+(\s|\S)*/,
  intThree: /^\d{0,3}$/,
  intFour: /^\d{0,4}$/,
  intSix: /^\d{0,6}$/,
  intSixFractionalTwoWithNegative: /^-?\d{0,6}(|\.\d{0,2})$/,
  intTwo: /^\d{0,2}$/,
  zeroToHundred: /^([0-9]|[1-9][0-9]|100)$/
};

export const dataType = {
  number: 1,
  string: 2,
  bool: 3
};

export const shipperOpsOfficeGroup = [
  { value: 1, label: "Alpharetta, GA" },
  { value: 2, label: "Amsterdam, NL" },
  { value: 3, label: "Atlanta, GA" },
  { value: 4, label: "Birmingham, AL" },
  { value: 5, label: "Chattanooga, TN" },
  { value: 6, label: "Chicago, IL" },
  { value: 7, label: "Columbus, OH" },
  { value: 8, label: "Denver, CO" },
  { value: 9, label: "Detroit, MI" },
  { value: 10, label: "Dover, UK" },
  { value: 11, label: "Guadalajara, Mexico" },
  { value: 12, label: "Jacksonville, FL" },
  { value: 13, label: "Knoxville, TN" },
  { value: 14, label: "Memphis, TN" },
  { value: 15, label: "Minneapolis, MN" },
  { value: 16, label: "Mobile, AL" },
  { value: 17, label: "Portland, OR" },
  { value: 18, label: "Trowbridge, UK" },
  { value: 19, label: "Wroclaw, PL" }
];

export const fscTypesIds = {
  dollarPerMile: 1,
  percentOfRate: 2,
  breakthrough: 3
};

export const repType = {
  none: 0,
  sales: 1,
  pricing: 2
};

/** Mirrors Coyote.Procurement.RFQ.Contracts.Enums.CloseLostDecision */
export const closeLostDecision = {
  customerDecision: 1,
  rxoDecision: 2
};

/** Mirrors CloseLostReasonCustomer (excluding Undefined) */
export const closeLostReasonCustomer = {
  bidCanceledOrPostponed: 1,
  capabilitySolutionTechnology: 2,
  contractualTerms: 3,
  noRelationship: 4,
  price: 5,
  marketStudy: 6,
  riskOfChange: 7,
  timeConstraintsMissedDeadline: 8
};

/** Mirrors CloseLostReasonRxo (excluding Undefined) */
export const closeLostReasonRxo = {
  capabilitySolutionTechnology: 1,
  capacity: 2,
  contractualTermsFinancialRisk: 3,
  internalResources: 4,
  relationship: 5,
  timeConstraintsMissedDeadline: 6
};

export const userTitle = {
  [userRole.salesRep]: messages.salesRepresentative.defaultMessage,
  [userRole.tlPricingAnalyst]: messages.tlPricingAnalyst.defaultMessage,
  [userRole.ltlPricingAnalyst]: messages.ltlPricingAnalyst.defaultMessage,
  [userRole.imdlPricingAnalyst]: messages.imdlPricingAnalyst.defaultMessage,
  [userRole.salesManager]: messages.salesManager.defaultMessage,
  [userRole.operations]: messages.operations.defaultMessage,
  [userRole.assetBasedPricingUser]:
    messages.assetBasedPricingUser.defaultMessage,
  [userRole.management]: messages.management.defaultMessage,
  [userRole.carrierRelationsRepresentative]:
    messages.carrierRelationsRepresentative.defaultMessage,
  [userRole.procurementRepresentative]:
    messages.procurementRepresentative.defaultMessage
};

export const keyCodes = {
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  enter: 13,
  f2: 113
};

export const awardType = [
  { value: 1, label: messages.flatRate.defaultMessage },
  { value: 2, label: messages.baseRpm.defaultMessage },
  { value: 3, label: messages.baseRpKm.defaultMessage }
];

export const analyticsFilterRankTypes = [
  { value: 201, label: messages.primary.defaultMessage },
  { value: 202, label: messages.backup.defaultMessage },
  { value: 203, label: messages.spot.defaultMessage }
];

export const awardRank = [
  { value: 1, label: messages.primary.defaultMessage },
  { value: 2, label: messages.secondary.defaultMessage },
  { value: 3, label: messages.backup.defaultMessage },
  { value: 4, label: messages.spot.defaultMessage }
];

export const bidSubmissionTypes = [
  { value: 0, label: messages.none.defaultMessage },
  { value: 1, label: messages.bidSite.defaultMessage },
  { value: 2, label: messages.email.defaultMessage }
];


export const rejectBidReasons = [
  {
    label: messages.shortLeadTime.defaultMessage,
    value: 1
  },
  {
    label: messages.moreInfoNeeded.defaultMessage,
    value: 2
  },
  {
    label: messages.doesNotMeetVolReq.defaultMessage,
    value: 3
  }
];

export const deleteItem = {
  document: 1,
  singleLane: 2,
  allLanes: 3
};

export const cellUnit = {
  none: "",
  percent: "%",
  dollar: "$",
  euro: "€"
};

export const divisionList = [
  {
    value: division.coy,
    label: messages.coyote.defaultMessage
  },
  {
    value: division.eu,
    label: messages.eu.defaultMessage
  }
];

export const userRoleList = [
  { value: 0, label: messages.none.defaultMessage },
  { value: 1, label: messages.salesRepresentative.defaultMessage },
  { value: 2, label: messages.tlPricingAnalyst.defaultMessage },
  { value: 3, label: messages.ltlPricingAnalyst.defaultMessage },
  { value: 4, label: messages.imdlPricingAnalyst.defaultMessage },
  { value: 6, label: messages.operations.defaultMessage },
  { value: 7, label: messages.assetBasedPricingUser.defaultMessage },
  { value: 8, label: messages.management.defaultMessage },
  { value: 9, label: messages.carrierRelationsRepresentative.defaultMessage },
  { value: 10, label: messages.procurementRepresentative.defaultMessage }
];

export const fileTypes = {
  email: "email",
  word: "word",
  pdf: "pdf",
  excel: "excel",
  picture: "picture"
};

export const notificationTypes = {
  userMessage: 1,
  general: 2,
  reminder: 3,
  systemMessage: 4,
  systemError: 5,
  systemSuccess: 6
};

export const bidStatusOptions = [
  { value: status.pending, label: statusText.pending },
  { value: status.inProgress, label: statusText.inProgress },
  { value: status.submitted, label: statusText.submitted },
  { value: status.feedback, label: statusText.feedback }
];

export const featureFlagTypes = [
  { key: "enableShipperRatesView", name: "enable_shipperrates_view" },
  {
    key: "enableInternalCapacityMatching",
    name: "enable_internalcapacitymatching"
  },
  { key: "useStrategicCostData", name: "use_strategic_cost_data" },
  { key: "useV2CarrierSearch", name: "use_v2_carrier_search" },
  { key: "enableDragAndDropForIcm", name: "enable_drag_and_drop_for_icm" },
  { key: "showSlicCodes", name: "show_slic_codes" },
  { key: "enableExportMatches", name: "enable_export_matches" },
  {
    key: "returnICMSummaryFromUpsertEndpoint",
    name: "return_icm_summary_from_upsert_endpoint"
  },
  {
    key: "enableTruckloadMatchLanesCountV3",
    name: "enable_truckload_match_lanes_count_V3"
  },
  {
    key: "enableRevvIntegration",
    name: "enable_revv_integration"
  },
  {
    key: "useAccountOpportunityNames",
    name: "use_account_opportunity_names"
  },
  {
    key: "useStrategicQuantile",
    name: "use_strategic_quantile"
  },
  {
    key: "hidePwbCost",
    name: "brokerage-rfq-fo139266-hide-pwb-cost"
  },
  {
    key: "enableTruckloadLaneImportV2",
    name: "enable_truckload_lane_import_v2"
  },
  {
    key: "useAttachmentV2Endpoint",
    name: "use_attachment_v2_endpoint"
  },
  {
    key: "enableAsyncLaneExport",
    name: "enable_async_lane_export"
  },
  {
    key: "useImportAwardsV2Endpoint",
    name: "use_import_awards_v2_endpoint"
  },
  {
    key: "useRxoUserAdmin",
    name: "use_rxo_user_admin"
  },
  {
    key: "enableCloseBidWon",
    name: "enable_close_bid_won"
  },
  {
    key: "enableCrmBidTeam",
    name: "enable_crm_bid_team"
  },
  {
    key: "enableBidSubmissionLoginDetails",
    name: "enable_bid_submission_login_details"
  },
  {
    key: "hideSendToPricingForSales",
    name: "hide_send_to_pricing_for_sales"
  },
  {
    key: "enableRxoTlPricingServerPagination",
    name: "rxo.brokerage.rfq.enable_rxo_tl_pricing_server_pagination"
  },
  {
    key: "disableFTLBid",
    name: "rxo.brokerage.rfq.disable_ftl_bid"
  },
  {
    key: "disableIMDLBid",
    name: "rxo.brokerage.rfq.crm_disable_imdl_bid"
  },
  {
    key: "crmEnableImdlUi",
    name: "rxo.brokerage.rfq.crm_enable_imdl_ui"
  },
  {
    key: "selfPricedCloseLost",
    name: "rxo.brokerage.rfq.self_priced_close_lost"
  },
  {
    key: "selfPricedCloseWon",
    name: "rxo.brokerage.rfq.self_priced_close_won"
  }
];

export const closedWonReason = {
  undefined: 0,
  capabilitySolutionTechnology: 1,
  incumbentIssues: 2,
  price: 3,
  relationship: 4,
  rxoPastPerformance: 5
};

export const closedWonReasonOptions = [
  {
    value: closedWonReason.capabilitySolutionTechnology,
    label: messages.closedWonReasonCapabilitySolutionTechnology.defaultMessage
  },
  {
    value: closedWonReason.incumbentIssues,
    label: messages.closedWonReasonIncumbentIssues.defaultMessage
  },
  {
    value: closedWonReason.price,
    label: messages.closedWonReasonPrice.defaultMessage
  },
  {
    value: closedWonReason.relationship,
    label: messages.closedWonReasonRelationship.defaultMessage
  },
  {
    value: closedWonReason.rxoPastPerformance,
    label: messages.closedWonReasonRxoPastPerformance.defaultMessage
  }
];

export const internationalLanesTypes = [
  { value: 1, label: messages.canada.defaultMessage },
  { value: 2, label: messages.mexico.defaultMessage },
  { value: 3, label: messages.both.defaultMessage },
  { value: 4, label: messages.no.defaultMessage },
];

export const loadAttributeTypes = [
  { value: "DropAndHook", label: messages.dropAndHook.defaultMessage },
  { value: "DropTrailerRequired", label: messages.dropTrailer.defaultMessage },
  {
    value: "EscortOrTwicRequired",
    label: messages.escortOrTwic.defaultMessage
  },
  { value: "LiquorPermit", label: messages.liquorPermit.defaultMessage },
  { value: "Twic", label: messages.twic.defaultMessage },
  {
    value: "ThroughTrailerOnly",
    label: messages.throughTrailer.defaultMessage
  },
  {
    value: "TransloadByCustomer",
    label: messages.transloadByShipper.defaultMessage
  },
  {
    value: "TransloadByCoyote",
    label: messages.transloadByCoyote.defaultMessage
  },
  { value: "IntraMexico", label: messages.intraMx.defaultMessage },
  {
    value: "CrossBorderMexico",
    label: messages.crossBorderMexico.defaultMessage
  },
  { value: "HazmatEndorsement", label: messages.hazMat.defaultMessage },
  { value: "Hvhr", label: messages.hvhr.defaultMessage },
  { value: "HvhrPlus", label: messages.hvhrPlus.defaultMessage },
  { value: "OverDimension", label: messages.overDimension.defaultMessage },
  { value: "PartialLoad", label: messages.partial.defaultMessage },
  {
    value: "TankerEndorsement",
    label: messages.tankerEndorsement.defaultMessage
  },
  { value: "Team", label: messages.team.defaultMessage }
];

export const filterEquipmentTypes = [
  { value: 1, label: "V", division: division.coy },
  { value: 2, label: "R", division: null },
  { value: 3, label: "F", division: division.coy },
  { value: 6, label: "SD", division: division.coy },
  { value: 8, label: "DD", division: division.coy },
  { value: 29, label: "K", division: division.coy },
  { value: 28, label: "G", division: division.coy },
  { value: 33, label: "BT", division: division.eu },
  { value: 11, label: "E", division: division.eu },
  { value: 16, label: "M", division: division.eu },
  { value: 12, label: "T", division: division.eu }
];

export const analyticsGridView = [
  {
    label: messages.laneView.defaultMessage,
    value: 1
  },
  {
    label: messages.shipperView.defaultMessage,
    value: 2
  }
];

export const analyticsGridViewV2 = [
  {
    label: messages.historicalLaneView.defaultMessage,
    value: 1,
    division: null
  },
  {
    label: messages.historicalShipperView.defaultMessage,
    value: 2,
    division: null
  },
  {
    label: messages.shipperRatesView.defaultMessage,
    value: 5,
    division: division.coy
  }
];

export const graphColors = {
  primary: "#3ABBD9",
  secondary: "#6CD57A",
  tertiary: "#76DDFB",
  frequency: "#2C82BE"
};

export const graphTypes = {
  seasonalityCost: 1,
  seasonalityCpm: 2,
  costFrequency: 3,
  cpmFrequency: 4,
  rankByVolume: 5,
  costByEquipment: 6
};

export const monthsAbbreviations = [
  messages.jan.defaultMessage,
  messages.feb.defaultMessage,
  messages.mar.defaultMessage,
  messages.apr.defaultMessage,
  messages.may.defaultMessage,
  messages.jun.defaultMessage,
  messages.jul.defaultMessage,
  messages.aug.defaultMessage,
  messages.sep.defaultMessage,
  messages.oct.defaultMessage,
  messages.nov.defaultMessage,
  messages.dec.defaultMessage
];

export const currencies = {
  dollar: "$",
  euro: "€"
};

export const costByEquipmentGraphColorCodes = {
  Van: "#50ADE6",
  Reefer: "#7DD778",
  "Open Deck": "#8364D9",
  "Box Trailer": "#E4875B",
  Euroliner: "#DD488B",
  Megatrailer: "#4E66D8",
  Tilt: "#3DA580"
};

export const opendeckEqTypes = ["F", "SD", "DD", "K", "G"];

export const analyticsView = {
  laneView: 1,
  shipperView: 2,
  loadView: 3,
  carrierView: 4,
  shipperRatesView: 5
};

export const currencyType = {
  USD: 1,
  EUR: 9
};

export const confidenceType = {
  green: 1,
  yellow: 2,
  red: 3
};

export const confidenceTypeColorCodes = [
  {
    value: confidenceType.green,
    color: "#ACD1AF",
    label: messages.green.defaultMessage
  },
  {
    value: confidenceType.yellow,
    color: "#EEEE9B",
    label: messages.yellow.defaultMessage
  },
  {
    value: confidenceType.red,
    color: "#F47174",
    label: messages.red.defaultMessage
  }
];

export const monthKeys = {
  1: messages.jan.defaultMessage,
  2: messages.feb.defaultMessage,
  3: messages.mar.defaultMessage,
  4: messages.apr.defaultMessage,
  5: messages.may.defaultMessage,
  6: messages.jun.defaultMessage,
  7: messages.jul.defaultMessage,
  8: messages.aug.defaultMessage,
  9: messages.sep.defaultMessage,
  10: messages.oct.defaultMessage,
  11: messages.nov.defaultMessage,
  12: messages.dec.defaultMessage
};

export const bidTypes = [
  { value: 1, label: messages.networkAnnual.defaultMessage },
  { value: 2, label: messages.networkSemiAnnual.defaultMessage },
  { value: 3, label: messages.networkQuarterly.defaultMessage },
  { value: 4, label: messages.miniBid.defaultMessage },
  { value: 5, label: messages.coyoteFleet.defaultMessage },
  { value: 0, label: messages.other.defaultMessage },
  { value: 6, label: messages.project.defaultMessage },
  { value: 7, label: messages.laneConversion.defaultMessage },
  { value: 8, label: messages.annual.defaultMessage },
  { value: 9, label: messages.marketStudy.defaultMessage },
  { value: 10, label: messages.monthly.defaultMessage },
  { value: 11, label: messages.quarterly.defaultMessage },
  { value: 12, label: messages.semiAnnual.defaultMessage }
];

export const numberOfRoundsOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" }
];

export const opportunityTypes = {
  other: 0,
  networkAnnual: 1,
  networkSemiAnnual: 2,
  networkQuarterly: 3,
  miniBid: 4,
  coyoteFleet: 5,
  project: 6,
  laneConversion: 7
};

export const analyticsDateRangeOptions = [
  { value: 1, months: 1, label: `1 ${messages.month.defaultMessage}` },
  { value: 2, months: 3, label: `3 ${messages.months.defaultMessage}` },
  { value: 3, months: 6, label: `6 ${messages.months.defaultMessage}` },
  {
    value: 4,
    months: 12,
    label: `12 ${messages.months.defaultMessage}`,
    default: true
  },
  { value: 5, months: -1, label: messages.custom.defaultMessage, custom: true }
];

export const breakdownGraphOptions = [
  {
    value: graphTypes.rankByVolume,
    label: messages.rankByVolume.defaultMessage
  },
  {
    value: graphTypes.costByEquipment,
    label: messages.costByEquipment.defaultMessage
  }
];

export const rankByVolumeGraphColorCodes = [
  {
    value: messages.primary.defaultMessage,
    color: "#2DA7DD"
  },
  {
    value: messages.backup.defaultMessage,
    color: "#5DDEFB"
  },
  {
    value: messages.spot.defaultMessage,
    color: "#0083C3"
  }
];

export const repriceReason = {
  none: 0,
  upload: 1,
  newRound: 2,
  staleBid: 3,
  manual: 4
};

export const modeType = {
  tl: "tl",
  ltl: "ltl",
  imdl: "imdl"
};

export const userRoleListForActiveBids = [
  { value: 1, label: messages.salesRepresentative.defaultMessage },
  { value: 2, label: messages.tlPricingAnalyst.defaultMessage },
  { value: 3, label: messages.ltlPricingAnalyst.defaultMessage },
  { value: 4, label: messages.imdlPricingAnalyst.defaultMessage },
  { value: 6, label: messages.operations.defaultMessage },
  { value: 7, label: messages.assetBasedPricingUser.defaultMessage },
  { value: 9, label: messages.carrierRelationsRepresentative.defaultMessage },
  { value: 10, label: messages.procurementRepresentative.defaultMessage }
];

export const userRoleListForPendingBids = [
  { value: 2, label: messages.tlPricingAnalyst.defaultMessage },
  { value: 3, label: messages.ltlPricingAnalyst.defaultMessage },
  { value: 4, label: messages.imdlPricingAnalyst.defaultMessage },
  { value: 6, label: messages.operations.defaultMessage },
  { value: 7, label: messages.assetBasedPricingUser.defaultMessage }
];

export const userRoleListForBidView = [
  { value: 1, label: messages.salesRepresentative.defaultMessage },
  { value: 2, label: messages.tlPricingAnalyst.defaultMessage },
  { value: 3, label: messages.ltlPricingAnalyst.defaultMessage },
  { value: 4, label: messages.imdlPricingAnalyst.defaultMessage },
  { value: 7, label: messages.assetBasedPricingUser.defaultMessage },
  { value: 9, label: messages.carrierRelationsRepresentative.defaultMessage },
  { value: 10, label: messages.procurementRepresentative.defaultMessage }
];

export const commitmentPeriods = [
  { value: 1, label: messages.commitmentAnnually.defaultMessage },
  { value: 2, label: messages.commitmentQuarterly.defaultMessage },
  { value: 3, label: messages.commitmentMonthly.defaultMessage },
  { value: 4, label: messages.commitmentWeekly.defaultMessage },
  { value: 5, label: messages.commitmentDaily.defaultMessage }
];

export const analyticsForecastedRangeOptions = [
  { value: 1, months: 1, label: `1 ${messages.month.defaultMessage}` },
  { value: 2, months: 3, label: `3 ${messages.months.defaultMessage}` },
  {
    value: 3,
    months: 6,
    label: `6 ${messages.months.defaultMessage}`,
    default: true
  },
  {
    value: 4,
    months: 12,
    label: `12 ${messages.months.defaultMessage}`
  },
  {
    value: 5,
    months: 18,
    label: `18 ${messages.months.defaultMessage}`
  },
  { value: 6, months: -1, label: messages.custom.defaultMessage, custom: true }
];

export const graphTypesV2 = {
  costOverTime: 1,
  cpmOverTime: 2,
  costFrequency: 3,
  cpmFrequency: 4
};

export const lineGraphSeries = {
  historical: "Historical",
  forecasted: "Forecasted"
};

export const shipperRatesMode = {
  1: "TL",
  2: "LTL",
  3: "IMDL",
  4: "R",
  5: "O",
  6: "A"
};

export const shipperRateTypes = {
  1: "Flat Rate",
  2: "Fuel Surcharge",
  3: "Per Mile",
  4: "Add on - Origin",
  5: "Advance Destination Amount",
  6: "Advance Fee",
  7: "Hazardous Materials",
  8: "Insurance Fee",
  9: "Miscellaneous - Destination",
  10: "Equipment Charges",
  11: "Miscellaneous - Origin",
  12: "Per Board Feet",
  13: "Blocking and Bracing Charge",
  14: "Bond Charges",
  15: "Chassis Equipment Lease Charge",
  16: "Cleaning/Sweeping of Trailer",
  17: "Per Cubic Meter",
  18: "Commission Amount",
  19: "Chassis Flip",
  20: "Chassis Split",
  21: "Per Hundred Weight",
  22: "Delivery Charge",
  23: "Diversion and Reconsignment",
  24: "Deadhead",
  25: "Drayage",
  26: "Yard Pull",
  27: "Detention Loading",
  28: "Equipment Detention (Origin)",
  29: "Equipment Detention (Destination)",
  30: "Detention Unloading",
  31: "Empty Movement",
  32: "Expedited Charge",
  33: "Excess Weight",
  34: "Percent Of Tariff Rate",
  35: "Per Foot",
  36: "Per Gross Ton",
  37: "Interstate/Highway Toll",
  38: "Intermodal Storage (Origin)",
  39: "Intermodal Storage (Destination)",
  40: "Per Kilograms",
  41: "Per Kilometer",
  42: "Layover Charges",
  43: "Per Pound",
  44: "Loading (Labor Charges)",
  45: "Crosstown Dray",
  46: "Per Long Ton",
  47: "Layover Service Charge",
  48: "Per Metric Ton (Tonne)",
  49: "Minimum",
  50: "Per Mile Per Vehicle (Rail Car) Moved",
  51: "Per Season",
  52: "One-Time Charge",
  53: "Per 20 Foot Equivalent (TEU)",
  54: "Per Cubic Foot",
  55: "Pier Termination",
  56: "Proof of Services",
  57: "Per Piece",
  58: "Per Hour",
  59: "Per Net Ton",
  60: "Pier Pass",
  61: "Per Gallon Per Mile",
  62: "Redelivery",
  63: "Rents and Leases",
  64: "Percent Of Rate",
  65: "Repair Charge",
  66: "Expired Reservation",
  67: "Scale Charge",
  68: "Special Equipment Charge",
  69: "Stop-off Charge",
  70: "Per Stop",
  71: "Spotting & Dropping",
  72: "Storage",
  73: "Yard Storage Offsite",
  74: "Technical Support and Setup Costs",
  75: "Stopping in Transit",
  76: "Combined Invoice Charge",
  77: "Carrier Equipment Pool Charge",
  78: "Tire Repair and Replace",
  79: "Driver Assist",
  80: "Driver Count",
  81: "Lumper Charges",
  82: "Unloading (Labor Charges)",
  83: "Unloading/Reloading Charge",
  84: "Equipment Ordered Not Used",
  85: "Service Charge",
  86: "COD Charge",
  87: "Lift Gate or Forklift Service at Pickup/Delivery",
  88: "Pallet Charge",
  89: "Equipment Detention (O+D)",
  90: "Equipment Detention (O+D+LHI)",
  91: "Escort Charge",
  92: "Appointment Change",
  93: "Vacuum Charge",
  94: "Wash Charge",
  95: "TWIC Card Fee",
  96: "GP Adjustments",
  97: "Per Loaded 436L Pallet",
  98: "Per Man Per Hour",
  99: "Per Unit",
  100: "Per Square Feet",
  101: "Processing Charge",
  102: "Heat in Transit Charges",
  103: "Overnight Service",
  104: "Rebate",
  105: "Refrigeration",
  106: "Shrink-Wrap Charge",
  107: "Supervisor Charge",
  108: "Tarping Charge",
  109: "Permit Charge",
  110: "Peak Season",
  111: "Team",
  112: "Discount",
  113: "Early Payment Allowance",
  114: "Warehouse Inbound",
  115: "Warehouse Outbound",
  116: "2nd Day Delivery",
  117: "Protective Service Charge",
  118: "Reconsignment Fee",
  119: "Notification Fee",
  120: "Demurrage",
  121: "VAT Charge",
  122: "Bill of Lading Charge",
  123: "Delivery Appointment Fee",
  124: "Sunday or Holiday Pickup or Delivery",
  125: "Saturday Pickup or Delivery Charge",
  126: "Out of Route Miles",
  127: "Export Customs",
  128: "Border Crossing Fee",
  129: "GST/HST Tax",
  130: "Special Detention charge",
  131: "Waiting Time",
  132: "BOL Correction Fee",
  133: "Guaranteed Delivery Fee",
  134: "Sort and Segmentation",
  135: "QST",
  136: "Access Charge",
  137: "Time Definite Service Fee",
  138: "Weight Determination/Verification Charge",
  139: "Blind Shipment Charge",
  140: "Single Shipment Charge",
  141: "Over Dimension Charge",
  142: "Stackable",
  143: "Turnkey",
  144: "Food Grade Products",
  145: "Inside Stop Charge",
  146: "Pallet Jack Charge",
  147: "Residential Stop Charge",
  148: "Marking or Tagging Charge",
  149: "Trade Show Stop Charge",
  150: "New York Stop Charge",
  151: "Limited Access Charge - Church",
  152: "Limited Access Charge - Construction Site",
  153: "Limited Access Charge - Military Base",
  154: "Limited Access Charge - Mine Site",
  155: "Limited Access Charge - Mini Storage",
  156: "Limited Access Charge - RemoteGovt Delivery",
  157: "Limited Access Charge - School",
  158: "Limited Access Charge - Other",
  159: "Blanket Service Charge",
  160: "Appointment Required Charge",
  161: "Invoice Adjustment",
  162: "Tanker Endorsement",
  163: "Dunnage Allowance",
  164: "Returned Load",
  165: "MX Linehaul Rate",
  166: "IVA (Mex VAT Tax)",
  167: "Customs Broker Fee",
  168: "Export Customs Clearance",
  169: "Single Entry Bond",
  170: "T DOC Issuance (IN BOND SURCHARGE) Broker",
  171: "Copy of Bill of Lading Charge",
  172: "Other Gov't Agency Releases",
  173: "Customs Inspections",
  174: "Import Service Fee",
  175: "Additional Clearance Fee",
  176: "Examination Station Fee",
  177: "Customs Presentation - DEST",
  178: "Agency Attendance for OFCB",
  179: "Preparation of Customs Form",
  180: "Additional Classifications",
  181: "Advance Disbursement Fee",
  182: "Mexican Broker Fee",
  183: "Customs Admin Fee",
  184: "Customs Examination",
  185: "Special OC-07 Brokerage Generated Charge",
  186: "Customs VAT/Duties",
  187: "Single Entry Bond Processing Fee",
  188: "HUB Service Fee",
  189: "Transload",
  190: "Detention at the Border",
  191: "Return Cargo Charge",
  192: "Bobtail Charges",
  193: "Ocean Freight",
  194: "Detention Without Power Unit",
  195: "Detention of Power Units",
  196: "Detention of Trailers",
  197: "Exhibition Delivery Charge",
  198: "Energy Surcharge (Fuel Adjustment Factor)",
  199: "Exclusive Use Charge",
  200: "Miscellaneous Charge",
  201: "Governmental Tax",
  202: "Terminal Charge",
  203: "Special Delivery",
  204: "Markup Charge",
  205: "Border Crossing Fee - Canada",
  206: "Cost Savings",
  207: "Ferry Charge",
  208: "Retention",
  209: "LTL Reclassification",
  210: "Pallet Exchange",
  211: "Mexico Liability Premium",
  212: "Tiered Rate",
  213: "Duty Charges",
  214: "BC Carbon Tax",
  215: "APHIS Fee",
  216: "Deduction",
  217: "Implementation Fee",
  218: "Management Fee CTM",
  219: "Reweigh",
  220: "Inspection",
  221: "Fuel Tax",
  222: "Demurrage Loading",
  223: "Demurrage Unloading",
  224: "IVA (Mex VAT) Discount",
  225: "Retention Discount",
  226: "Non-Revenue Impacting",
  227: "3rd Party Payor Discount",
  228: "Protect From Freeze",
  229: "Hazmat",
  230: "Guaranteed 10AM",
  231: "Guaranteed 12PM",
  232: "Guaranteed 5PM",
  233: "Guaranteed MAPD",
  234: "Guaranteed RAD",
  235: "Appointment Required DEL",
  236: "Liftgate PU",
  237: "Liftgate DEL",
  238: "Residential PU",
  239: "Residential DEL",
  240: "Inside PU",
  241: "Inside DEL",
  242: "Tradeshow PU",
  243: "Tradeshow DEL",
  244: "Sort and Segregate PU",
  245: "Sort and Segregate DEL",
  246: "Limited Access PU - School",
  247: "Limited Access PU - Remote Govt Delivery",
  248: "Limited Access PU - Mini Storage",
  249: "Limited Access PU - Military Base",
  250: "Limited Access PU - Church",
  251: "Limited Access PU - Other",
  252: "Limited Access PU - Construction Site",
  253: "Limited Access PU - Mine Site",
  254: "Limited Access PU - Airport",
  255: "Limited Access PU - Farm",
  256: "Limited Access PU - Prison",
  257: "Limited Access DEL - School",
  258: "Limited Access DEL - Remote Govt Delivery",
  259: "Limited Access DEL - Mini Storage",
  260: "Limited Access DEL - Military Base",
  261: "Limited Access DEL - Church",
  262: "Limited Access DEL - Other",
  263: "Limited Access DEL - Construction Site",
  264: "Limited Access DEL - Mine Site",
  265: "Limited Access DEL - Airport",
  266: "Limited Access DEL - Farm",
  267: "Limited Access DEL - Prison",
  268: "Household Goods",
  269: "Notify/Call Before Delivery",
  270: "California Surcharge/CARB",
  271: "Attempted PU",
  272: "NYC Surcharge",
  273: "Access - Security",
  274: "Cubic Capacity",
  275: "High Cost Delivery Area",
  276: "Alcohol Reporting Fee",
  277: "California Surcharge",
  278: "Unpack/Detrash"
};

export const capacityMatchingStatus = {
  undefined: 0,
  pending: 1,
  rejected: 2,
  inProgress: 3,
  submitted: 4,
  review: 5
};

export const carrierMatchingEqTypes = [
  { value: 1, label: "V" },
  { value: 2, label: "R" },
  { value: 3, label: "F" },
  { value: 18, label: "P" }
];

export const assetType = [
  { value: 1, label: "CR" },
  { value: 2, label: "PF" },
  { value: 3, label: "UPS" },
  { value: 4, label: "MSR" },
  { value: 5, label: "FlexSolution" }
];

export const odLoadingTypes = [
  { value: 1, label: messages.liveOrLive.defaultMessage },
  { value: 2, label: messages.liveOrDrop.defaultMessage },
  { value: 4, label: messages.dropOrLive.defaultMessage },
  { value: 8, label: messages.dropOrDrop.defaultMessage }
];

export const strategyDurationOptions = [
  { value: 1, months: 1, label: `1 ${messages.month.defaultMessage}` },
  { value: 2, months: 2, label: `2 ${messages.months.defaultMessage}` },
  { value: 3, months: 3, label: `3 ${messages.months.defaultMessage}` },
  { value: 4, months: 4, label: `4 ${messages.months.defaultMessage}` },
  { value: 5, months: 5, label: `5 ${messages.months.defaultMessage}` },
  { value: 6, months: 6, label: `6 ${messages.months.defaultMessage}` },
  { value: 7, months: 7, label: `7 ${messages.months.defaultMessage}` },
  { value: 8, months: 8, label: `8 ${messages.months.defaultMessage}` },
  { value: 9, months: 9, label: `9 ${messages.months.defaultMessage}` },
  { value: 10, months: 10, label: `10 ${messages.months.defaultMessage}` },
  { value: 11, months: 11, label: `11 ${messages.months.defaultMessage}` },
  { value: 12, months: 12, label: `12 ${messages.months.defaultMessage}` },
  { value: 13, months: 13, label: `13 ${messages.months.defaultMessage}` },
  { value: 14, months: 14, label: `14 ${messages.months.defaultMessage}` },
  { value: 15, months: 15, label: `15 ${messages.months.defaultMessage}` },
  { value: 16, months: 16, label: `16 ${messages.months.defaultMessage}` },
  { value: 17, months: 17, label: `17 ${messages.months.defaultMessage}` },
  { value: 18, months: 18, label: `18 ${messages.months.defaultMessage}` }
];

export const bidScacType = [
  { value: 1, label: messages.coyote.defaultMessage },
  { value: 2, label: messages.rxo.defaultMessage }
];

export const rateType = [
  { value: 1, label: "LTL" },
  { value: 2, label: "LT3" },
  { value: 3, label: "LT5" },
  { value: 4, label: "LTC" },
  { value: 5, label: "LTS" },
  { value: 6, label: "LTZ" },
  { value: 7, label: "3TL" },
  { value: 8, label: "3T3" },
  { value: 9, label: "3T5" },
  { value: 10, label: "3TC" },
  { value: 11, label: "3TS" },
  { value: 12, label: "3TZ" },
  { value: 13, label: "5TL" },
  { value: 14, label: "5T5" },
  { value: 15, label: "5TC" },
  { value: 16, label: "5T3" },
  { value: 17, label: "5TS" },
  { value: 18, label: "5TZ" },
  { value: 19, label: "CTL" },
  { value: 20, label: "CT3" },
  { value: 21, label: "CT5" },
  { value: 22, label: "CTS" },
  { value: 23, label: "CTC" },
  { value: 24, label: "CTZ" },
  { value: 25, label: "STL" },
  { value: 26, label: "ST5" },
  { value: 27, label: "STS" },
  { value: 28, label: "ST3" },
  { value: 29, label: "STC" },
  { value: 30, label: "STZ" },
  { value: 31, label: "ZTL" },
  { value: 32, label: "ZT3" },
  { value: 33, label: "ZT5" },
  { value: 34, label: "ZTC" },
  { value: 35, label: "ZTS" },
  { value: 36, label: "ZTZ" }
];

export const equipmentTypeDetails = {
  1: "Van",
  2: "Van Double",
  3: "Van Airride",
  4: "Cargo Van",
  5: "Van Roller Bed",
  6: "Van Curtain",
  7: "Van or Flatbed",
  8: "Van Lift Gate",
  9: "Van Hotshot",
  10: "Van Insulated",
  11: "Van Logistics",
  12: "Van w/ Team",
  13: "Van Intermodal",
  14: "Van - 53 Feet",
  15: "Van/Reefer - 48",
  16: "Van/Reefer - 53",
  17: "Van Conestoga",
  18: "Van w/ Tarps",
  19: "Van Vented",
  20: "Van Hazmat",
  21: "Van/Reefer",
  22: "V/R With Team",
  23: "V/R Hazmat",
  24: "Van High Cube",
  25: "Moving Van",
  26: "Flatbed Maxi",
  27: "Removable GN",
  28: "Flatbed",
  29: "Step Deck",
  30: "Stretch Trailer",
  31: "FB w/ Tarps",
  32: "Flatbed Hazmat",
  33: "Flatbed B-Train",
  34: "Drop Deck, Landoll",
  35: "Lowboy",
  36: "Double Drop",
  37: "Dump Trailer",
  38: "OverDimensional",
  39: "Flatbed - 45",
  40: "Flatbed - 48",
  41: "Flatbed - 53",
  42: "Flatbed - 53",
  43: "Flatbed Airride",
  44: "Flatbed/Step Deck",
  45: "Flatbed Hotshot",
  46: "Flatbed w/ Team",
  47: "RGN Extendable",
  48: "StepDeck 48 ft",
  49: "StepDeck 53 ft",
  50: "Reefer",
  51: "Reefer Logistics",
  52: "Reefer w/ Team",
  53: "Reefer Intermodal",
  54: "Reefer Hazmat",
  55: "Reefer Doubles",
  56: "Reefer - 48",
  57: "Reefer - 53",
  58: "Reefer Airride"
};

export const target = [
  { value: 1, label: "Yes" },
  { value: 2, label: "No" },
  { value: 3, label: "Inc" }
];

export const targetType = [
  { value: 1, label: messages.primaryIncumbent.defaultMessage },
  { value: 2, label: messages.convertActiveNonPrimary.defaultMessage },
  { value: 3, label: messages.similartoPrimaryIncumbent.defaultMessage },
  { value: 4, label: messages.networkILA.defaultMessage },
  { value: 5, label: messages.noFlyZone.defaultMessage },
  { value: 6, label: messages.general.defaultMessage },
  { value: 7, label: messages.noTargetType.defaultMessage }
];

export const customerFeedbackType = [
  { value: 1, label: messages.target.defaultMessage },
  { value: 2, label: messages.percentage.defaultMessage },
  { value: 3, label: messages.trafficLight.defaultMessage },
  { value: 4, label: messages.rank.defaultMessage },
  { value: 5, label: messages.quartile.defaultMessage },
  { value: 6, label: messages.general.defaultMessage }
];
